import Container from 'react-bootstrap/Container';
import { Alert, Button, Card, Table, Modal, Accordion, Form } from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {CallAPI, Loading, SpinnerX, Check, CallAPIGet} from '../../services/useBackend';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import {MaterialReactTable} from 'material-react-table';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle, metaLookUpAccountTitle} from '../../services/misc';
import { FaEdit, FaEraser, FaSortDown, FaSortUp, FaDownload, FaCheck } from 'react-icons/fa';

export default function Test(props) {
    const [saving,        setSaving]        = useState(false);
    const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);

    var typingTimeout = null;

	async function handleChange(event){
        clearTimeout(typingTimeout);
		// typingTimeout = setTimeout(handleSave, 475);
	}

	async function handleSave(e){
        e.preventDefault();
		setSaving(true);
		setResultText("");
		setResultVisible(false);
		const VerificationForm = document.getElementById('NewCompanyForm');
		const formData = new FormData(VerificationForm);
		const formDataObj = Object.fromEntries(formData.entries());

        let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/company',"POST",JSON.stringify(formDataObj));
        if (resultVariant!="success") {
            setResultVariant(resultVariant);
            setResultText(resultText);
            setResultVisible(resultVisible);
        } else {
            console.log(".........");
            props.RefreshFn();
        }
		setSaving(false);
	}

    return (
        <>      
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Skapa nytt företag</Accordion.Header>
                    <Accordion.Body>
                    För att kunna bokföra behöver du skapa ett företag, det behöver inte vara samma företag som du angav när du registrerade kontot.
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

                <Form id='NewCompanyForm' name='NewCompanyForm'  onSubmit={handleSave}>
                    <Form.Group className="mb-3" >
                        <Form.Label>Företagsnamn</Form.Label>								                            
                        <Form.Control type="text" name="FNAMN" id="FNAMN" placeholder="Företagsnamn" onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Organisationsnummer</Form.Label>								                            
                        <Form.Control type="text" name="ORGNR" id="ORGNR" placeholder="Organisationsnummer" onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Kontoplan</Form.Label>								                            
                        <Form.Select name="KPTYP" id="KPTYP"  placeholder="Kontoplan" onChange={handleChange} >
                            <option>--- Välj ---</option>
                            <option value={"EUBAS97"}>EUBAS97</option>                            
                        </Form.Select>&nbsp;
                    </Form.Group>                    

                    <Form.Group className="mb-3"  hidden={!saving}>
                        <SpinnerX  />
                    </Form.Group>                                      
                    
                    <Form.Group className="mb-3"  hidden={!resultVisible}>
                        <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                    </Form.Group> 

                    <Form.Group className="mb-3">
                        <Button className="QmeButton" variant="primary" type="submit">Spara</Button>
                    </Form.Group>                     
                </Form>  											 													
        </>
      );      
};